$(function() {

	$(window).scroll(function() {
		if($(window).scrollTop() < $("#productInfo").offset().top){
			$("#hachiBG2").css("display","none");
			$("#productInfoBG").css("display","block");
		}else{
			$("#hachiBG2").css("display","block");
			$("#productInfoBG").css("display","none");
		}
	});
	var hachiKV = new HachiKV();
	hachiKV.init();
	$(window).bind("resize",function(){hachiKV.setKVPos();});

	// window.onload = function(){
	// 	hachiKV.kvAnim();
	// }
	window.addEventListener('load', function() {
		hachiKV.kvAnim();
	});

	inView(".inView").on("enter",el=>{$(el).removeClass("inView");});
	inView(".inViewOpacity").on("enter",el=>{$(el).removeClass("inViewOpacity");});
	inView(".inViewTarget").on("exit",el=>{$(el).addClass("inView");});
	inView(".inViewTargetOpacity").on("exit",el=>{$(el).addClass("inViewOpacity");});
	inView(".inViewText").on("enter",el=>{$(el).addClass("inViewTextOn");});
	inView(".inViewText").on("exit",el=>{$(el).removeClass("inViewTextOn");});
	$(window).scroll(function() {
		hachiKV.setPhotoParallax($("#wabutterPhotoWrapper"),false);
		hachiKV.setPhotoParallax($("#oridoraPhotoWrapper"),false);
		if($(window).scrollTop() > 10 &&
			$(window).scrollTop() < $(".productList").offset().top - $(window).height()
		){
			$("#hachiToCollection").addClass("toOn");
		}else{
			$("#hachiToCollection").removeClass("toOn");
		}
	});
});
function hachiGoToCorrection(){
	if($("#hachiToCollection").hasClass("toOn")){
		var position = $(".productList").offset().top - $("#shopify-section-fr-header").height();
		$("html,body").animate({scrollTop:position},1200);
	}
}

var HachiKV = function(){
	var self = this;
	self.zure = new Array();

	self.targetRange = 30;
	self.init = function(){
		if(!$("#hachiBG").length){
			$("body").append("<div id='hachiBG'></div>");
		}
		if(!$("#hachiBG2").length){
			$("body").append("<div id='hachiBG2'></div>");
		}
		if(!$("#hachiToCollection").length){
			$("body").append("<div id='hachiToCollection'><a href='javascript:hachiGoToCorrection()'><img src='https://cdn.shopify.com/s/files/1/0393/8235/1917/files/hachi-tocollection.svg?v=1654007759' /></a></div>");
		}
		if(!$(".shopify-section--main-collection .toBrandSite").length){
			$(".shopify-section--main-collection").append("<div class='toBrandSite' style='margin-bottom:60px;'><a href='https://hachi.buttersand.com/' target='_blank'><img src='https://cdn.shopify.com/s/files/1/0393/8235/1917/files/hachi-viewBrandSite.svg?v=1654007759' /></a></div>");
		}

		self.setKVPos();
	}
	self.setKVPos = function(){
		console.log("setKVPos")
		var h1 = $("#shopify-section-header-announcement").height();
		var h2 = $("#shopify-section-fr-header").height();
		var h3 = $("#fsb_background").height();
		var headerHeight = h1 + h2;
		var fixer = headerHeight + h3;
		$("#kv").css("margin-top",h2+"px");
		$("#kv").css("height","calc(100vh - "+fixer+"px)");
		if($(window).width() > 768){
			self.setKVPC();
		}else{
			$("#kvMain").css("width","100%");
			$("#kvMain").css("left","0px");
		}
	}
	self.setKVPC = function(){
		console.log("setKVPC")
			var kvMainWidth = $("#kvMain").height()*(948/850);
			$("#kvMain").width(kvMainWidth);
			var w = $(window).width() - kvMainWidth;
			var l = w/2 + 250 ;
			$("#kvMain").css("left",l+"px");

			var logoL = l-$("#kvLogo").width();
			$("#kvLogo").css("left",logoL+"px");

			var conceptL = logoL + ($("#kvLogo").width()-$("#kvConcept").width())/2;
			$("#kvConcept").css("left",conceptL+"px");

			var logoBottonMgn = 100;
			var logoConceptHeight = $("#kvLogo").height() + $("#kvConcept").height();
			var mgn = ($("#kvMain").height() - (logoConceptHeight + logoBottonMgn))/2;
			$("#kvLogo").css("top",mgn+"px");
			$("#kvConcept").css("bottom",mgn+"px");

			var cWidth = $("#kvLogo").width()+kvMainWidth;
			//console.log(cWidth,$("#kvMain").width(),kvMainWidth,$(window).width());
			cWidth*=1.2;
			if(cWidth > $(window).width()){
				var sa = $(window).width() /cWidth;
				sa = Math.floor(sa*100);
				//console.log("sa",sa,cWidth);
				$("#kvContent").css("transform","scale("+sa+"%)");
			}
	}
	self.setPhotoParallax = function(elm,force){
		var pos = elm.offset().top - $(window).scrollTop();
		var bottom = $(window).height();
		var top = $("#shopify-section-fr-header").height() - elm.height();
		////console.log(pos,bottom,top);
		if((pos < bottom  && top < pos) || force){
			var range = bottom - top;
			var current = pos -top;
			var percent = ((current/range) - 0.5)*2;

			/*
			var pramai = 1;
			if(percent < 0){
				pramai = -1;
			}
			percent = percent * 1.2;
			percent = percent * percent ;
			percent = percent/1.44 * pramai;
			*/

			var id = elm.attr("id");
			var img = elm.find("img");
			var zure = 50;
			if(typeof self.zure[id] != "undefined"){
				zure = self.zure[id];
			}
			var target = Math.floor(self.targetRange * percent + 50);
			var targetPos = zure + (target - zure)/2;
			//targetPos = target;//いーじんぐなし
			var transformY = (50 - targetPos)/2;
			////console.log(target,targetPos);
			////console.log(img.height());
			var cssString = "50% "+targetPos+"%";
			self.zure[id] = targetPos;

			//elm.css("opacity","0.5");
			////console.log(elm.css("-webkit-mask-position"));
			img.css("mask-position",cssString);
			img.css("-webkit-mask-position",cssString);
			img.css("transform","translateY("+transformY+"%)");
		}else{
			//console.log("-");
		}
	}
	self.kvAnim = function(){
		setTimeout(function(){
			$("#kvLogo").removeClass("kvLogoStandby");
		},50);
		setTimeout(function(){
			$("#kvMain").removeClass("kvMainStandby");
		},1000);

		setTimeout(function(){
			$("#kvConcept01").addClass("on");
		},2000);
		setTimeout(function(){
			$("#kvConcept02").addClass("on");
		},2600);
		setTimeout(function(){
			$("#kvConcept03").addClass("on");
		},3200);
		setTimeout(function(){
			$("#kvConcept04").addClass("on");
		},3800);

	}

}